export default __webpack_public_path__ + "static/media/logo.b88422f4.jpeg";